import React, { useState, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { AppState } from '../../context';
import { DataTableContainer, StyledTable } from "./styles";
import { Checkbox } from '@material-ui/core';
import { dbTasks, dbPending, dbFamtoFam, dbCaregivers } from '../../firebase';
import AdminHeaderBar from './AdminHeader'

/**
 * Page representing all tasks related to a particular senior.
 * @returns {JSX} page containing a MUI datatable
 */
export default function AdminTasks(props) {

  const { id, senior } = useParams();
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState('');

  // Global store state from AppSate
  const someContext = useContext(AppState);
  const {
    pending,
    famtofam,
    caregivers,
    familyMembers,
    seniors,
    tasks
  } = someContext;

  // Options for the columns
  const columnOptions = {
    filter: true,
    sort: true
  };

  // Column headers and options
  const columns = [
    {
      name: "taskname",
      label: "Task Name",
      options: columnOptions
    },
    {
      name: "taskfor",
      label: "To be Completed By",
      options: columnOptions
    },
    {
      name: "viewnotes",
      label: "Description",
      options: columnOptions
    },
    {
      name: "status",
      label: "Status",
      options: columnOptions
    },
    {
      name: "check",
      label: "Change Status",
      options: {
        filter: false,
        sort: false
      }
    },
  ];

  // Generates the table data with tasks
  const generateData = (family) => {
    let tempData = [];

    // This is for Database reference Tasks
    Object.values(family["tasks"]).map(task => {
      if (tasks[task]) {
        function handleChange() {
          dbTasks.child(task).child('status').set(!tasks[task]['status'])
        }
        tempData.push({
          taskname: tasks[task]["taskName"],
          taskfor: caregivers[tasks[task]["caregiverId"]] ? caregivers[tasks[task]["caregiverId"]]["firstName"] + " " + caregivers[tasks[task]["caregiverId"]]["lastName"] : "-",
          viewnotes: tasks[task]["description"],
          status: tasks[task]["status"] ? "Complete" : "Incomplete",
          check: <Checkbox
            checked={tasks[task]["status"]}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        })
      }
    })

    // This is for Database reference of FamtoFam
    Object.values(family["taskstofam"]).map(task => {
      if (famtofam[task]) {
        function handleChange() {
          console.log(!famtofam[task]["status"])
          dbFamtoFam.child(task).child('status').set(!famtofam[task]['status'])
        }
        tempData.push({
          taskname: famtofam[task]["taskName"],
          taskfor: familyMembers[famtofam[task]["AssignedtoFam"]] ? familyMembers[famtofam[task]["AssignedtoFam"]]["firstName"] + " " + familyMembers[famtofam[task]["AssignedtoFam"]]["lastName"] : "-",
          viewnotes: famtofam[task]["description"],
          status: famtofam[task]["status"] ? "Complete" : "Incomplete",
          check: <Checkbox
            checked={famtofam[task]["status"]}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        })
      }
    })

    // This is for Database reference of Unassigned
    if (family["unassignedTasks"] != "null") {
      Object.values(family["unassignedTasks"]).map(task => {
        if (pending[task]) {
          function handleChange() {
            dbPending.child(task).child('status').set(!pending[task]['status'])
          }
          tempData.push({
            taskname: pending[task]["taskName"],
            taskfor: "Unassigned",
            viewnotes: pending[task]["description"],
            status: pending[task]["status"] ? "Complete" : "Incomplete",
            check: <Checkbox
              checked={pending[task]["status"]}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          })
        }
      })
    }

    // This is for Database reference for Caregiver ToDolist
    if (family["careBool"]) {
      Object.values(family["caregivers"]).map(caregiver => {
        Object.entries(caregivers[caregiver]["todolist"]).map(task => {
          console.log(task)
          if (task[1]["type"]) {
            function handleChange() {
              dbCaregivers.child(caregiver).child('todolist').child(task[0]).child('status').set(!task[1]['status'])
            }
            tempData.push({
              taskname: task[1]["type"],
              taskfor: family["firstName"] + " " + family["lastName"],
              viewnotes: task[1]["detail"],
              status: task[1]["status"] ? "Complete" : "Incomplete",
              check: <Checkbox
                checked={task[1]["status"]}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            })
          }
        })
      })
    }

    // This is for Database reference for Secondary Fam
    if (family["secondaryFam"] != "hi") {
      Object.values(family["secondaryFam"]).map(member => {
        if (familyMembers[member]["taskstofam"]) {
          Object.values(familyMembers[member]["taskstofam"]).map(task => {
            if (famtofam[task]) {
              function handleChange() {
                console.log(!famtofam[task]["status"])
                dbFamtoFam.child(task).child('status').set(!famtofam[task]['status'])
              }
              tempData.push({
                taskname: famtofam[task]["taskName"],
                taskfor: familyMembers[famtofam[task]["AssignedtoFam"]] ? familyMembers[famtofam[task]["AssignedtoFam"]]["firstName"] + " " + familyMembers[famtofam[task]["AssignedtoFam"]]["lastName"] : "-",
                viewnotes: famtofam[task]["description"],
                status: famtofam[task]["status"] ? "Complete" : "Incomplete",
                check: <Checkbox
                  checked={famtofam[task]["status"]}
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              })
            }
          })
        }
      })
    }

    setData(tempData);
    return tempData;
  }

  const onChangeRowsPerPage = numberOfRows => {
    setRowsPerPage(numberOfRows);
  }

  // Override options for MUI datatable
  const options = {
    draggableColumns: {
      enabled: true
    },
    print: true,
    selectableRows: "none",
    responsive: "simple",
    onChangeRowsPerPage: onChangeRowsPerPage,
    searchText: searchValue,
    searchPlaceholder: 'Search all Tasks',
    onSearchChange: (searchText) => setSearchValue(searchText),
  };


  // Generates table data and keeps tab on global store
  useEffect(() => {
    if (familyMembers && caregivers && seniors && tasks && famtofam && pending) {
      generateData(familyMembers[id]);
    }
  }, [familyMembers, caregivers, seniors, tasks, famtofam, pending]);


  return (
    <div>
       <AdminHeaderBar notes={true} id={id} senior={senior} />
      <DataTableContainer maxWidth={"lg"}>
        <StyledTable
          title={`All Tasks for ${senior}`}
          data={data}
          columns={columns}
          options={options}
        />
      </DataTableContainer>
    </div>
  )
}